import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import CustomBorder from "../_UI/customBorder";
import {useNavigate} from "react-router-dom";



const PreSaleS1 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.titleWrap}`}>
                    <div className={`${Styles.title}`}>$TC {t('Пресейл')}</div>
                </div>
                <div className={`${Styles.subTitle}`}>{t('Будущее идентичности начинается сейчас')}</div>
                <div className={`${Styles.note}`}>{t('Time Capsule создает инфраструктуру для цифровой идентичности и сохранения памяти. Присоединяйтесь к пресейлу и станьте частью системы, которая выходит за пределы времени.')}</div>
                <div className={`${Styles.subNote}`}>{t('Ранний доступ. Ограниченная аллокация.')}</div>
                <div className={`${Styles.btnWrap}`}>
                    <CustomBorder corners={{ topRight: true, bottomLeft: true }} fill="#1A1600" borderColor="#FFD700" withHover={true}>
                        <button className={`${Styles.btn}`} onClick={()=>{navigate('/sign-in')}}><div>{t('Купить токены')}</div></button>
                    </CustomBorder>
                </div>
            </div>
        </section>
    );
};

export default PreSaleS1;